module.exports = __webpack_public_path__ + "img/outDNAtop.127b5b03.png";